module.exports = {
    realtime: {
        provider: 'sockjs',
        prefix: '/sockjs'
    },
    raygun: {
        apiKey: 'olWxUdocLWq5HFOwJZephw=='
    }
};
